/* aurora-cart.js — ALL cart behaviour in one file (drawer + /cart page).
   Merged from 4 scripts to cut 4 requests to 1 (the drawer renders on every page) and to
   share a single delegated listener + one observer instead of three. Every part guards on
   its own DOM, so loading it globally costs nothing when a feature isn't used.

   1) Section-id fix (CRITICAL)  2) Terms gate  3) Cart tools popups  4) Recently viewed  5) Upsell arrows
   (scroll lock + position keep is global — aurora.css html:has() + the inline keeper in theme.liquid) */
(function () {
  if (window.__auroraCart) return;
  window.__auroraCart = true;

  /* --- 1) SECTION-ID FIX -----------------------------------------------------
     Dawn's cart.js re-renders via ?sections=cart-drawer, but inside the "Overlay"
     section group the real id is sections--<id>__cart-drawer. The bare name returns a
     BLOCKLESS render, which would wipe every block on each cart update. */
  function realId() {
    var w = document.querySelector('[id^="shopify-section-"][id*="__cart-drawer"]');
    return w ? w.id.replace('shopify-section-', '') : 'cart-drawer';
  }
  function patch(name) {
    if (!window.customElements || !customElements.whenDefined) return;
    customElements.whenDefined(name).then(function () {
      var C = customElements.get(name);
      if (!C || !C.prototype || typeof C.prototype.getSectionsToRender !== 'function' || C.prototype.__auroraFix) return;
      var orig = C.prototype.getSectionsToRender;
      C.prototype.getSectionsToRender = function () {
        var arr = orig.call(this) || [];
        var id = realId();
        if (id !== 'cart-drawer') {
          arr.forEach(function (s) {
            // product-form.js builds ?sections= from .id; renderContents reads sections[.id]
            if (!s) return;
            if (s.id === 'cart-drawer') s.id = id;
            if (s.section === 'cart-drawer') s.section = id;
          });
        }
        return arr;
      };
      C.prototype.__auroraFix = true;
    }).catch(function () {});
  }
  patch('cart-drawer-items');
  patch('cart-drawer');

  /* --- 2) TERMS GATE — checkout disabled until agreed (drawer + /cart) ------- */
  function gate() {
    document.querySelectorAll('button[name="checkout"]').forEach(function (btn) {
      var box = btn.closest('cart-drawer') || btn.closest('#main-cart-footer') || btn.closest('.cart__footer') || btn.closest('form') || document.body;
      var cb = box.querySelector('[data-aurora-terms]');
      if (!cb) return;
      cb.checked ? btn.removeAttribute('disabled') : btn.setAttribute('disabled', '');
      if (!cb.dataset.b) { cb.dataset.b = '1'; cb.addEventListener('change', gate); }
    });
  }

  /* --- 3) CART TOOLS — note / shipping / discount popups --------------------- */
  function drawerEl() { return document.querySelector('cart-drawer, .cart-drawer'); }
  function closeAll() {
    document.querySelectorAll('[data-aurora-modal]').forEach(function (m) { m.hidden = true; });
    var d = drawerEl(); if (d) d.classList.remove('aurora-cart--modal');
  }
  function open(name) {
    closeAll();
    var m = document.querySelector('[data-aurora-modal="' + name + '"]');
    if (!m) return;
    m.hidden = false;
    var d = drawerEl(); if (d) d.classList.add('aurora-cart--modal');
    var f = m.querySelector('textarea, input');
    if (f) setTimeout(function () { f.focus(); }, 40);
  }
  /* Apply a discount WITHOUT leaving the page.

     `/discount/CODE` sets the code and then redirects — to the HOME PAGE by default. Sending
     the browser there threw the shopper out of the cart drawer every time they entered a
     code, which is the one moment they are closest to checking out. Fetching the same URL
     sets the code just as well (it is the cookie that matters, not the page it lands on),
     and the drawer is then re-rendered in place so the new total shows.

     Shopify does not report a bad code: it applies nothing and says nothing. So the cart is
     read back afterwards and the code looked for there — the only honest way to tell the
     shopper their code did not take. */
  function discountMsg(scope, text, ok) {
    var el = scope && scope.querySelector('[data-aurora-discount-msg]');
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
    el.classList.toggle('is-error', text && !ok);
  }
  function refreshCart() {
    var target = document.querySelector('#CartDrawer');
    var id = realId();
    if (!target) return Promise.resolve();
    return fetch('/cart?sections=' + encodeURIComponent(id), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data[id];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#CartDrawer');
        if (!fresh) return;

        /* Swap the PANEL only, never the whole of #CartDrawer.

           #CartDrawer-Overlay is the click-outside-to-close target, and Dawn binds that
           listener in the cart-drawer constructor — once, on the node that existed then.
           Replacing #CartDrawer's children threw that node away and the new one came back
           deaf: after applying a code, clicking outside the drawer did nothing.

           Swapping .drawer__inner leaves the overlay untouched, so the listener it was born
           with still works. The class list comes across too, because `is-empty` lives there
           and decides how the panel renders. */
        var liveInner = target.querySelector('.drawer__inner');
        var freshInner = fresh.querySelector('.drawer__inner');
        if (liveInner && freshInner) {
          liveInner.innerHTML = freshInner.innerHTML;
          liveInner.className = freshInner.className;
        } else {
          /* markup we do not recognise: fall back to the full swap, then re-bind the
             overlay by hand the way Dawn does after its own re-render */
          target.innerHTML = fresh.innerHTML;
          var drawer = document.querySelector('cart-drawer');
          var ov = target.querySelector('#CartDrawer-Overlay');
          if (drawer && ov && typeof drawer.close === 'function') {
            ov.addEventListener('click', drawer.close.bind(drawer));
          }
        }
        gate();
        pinLayout();
      })
      .catch(function () {});
  }
  function discount(input) {
    var c = (input && input.value || '').trim();
    if (!c) return;
    var scope = input.closest('.aurora-cart-disc') || input.closest('[data-aurora-modal]') || input.parentElement;
    var T = input.dataset;
    var onCartPage = !document.querySelector('#CartDrawer') || !!input.closest('#main-cart-footer, .cart__footer, .aurora-cart-page');
    discountMsg(scope, T.tApplying || '', true);
    fetch('/discount/' + encodeURIComponent(c), { credentials: 'same-origin' })
      .then(function () {
        /* the cart page shows the discount in its own totals, so reload it — still the
           cart, never the home page */
        if (onCartPage) { window.location.reload(); return null; }
        return refreshCart().then(function () {
          return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
        });
      })
      .then(function (cart) {
        if (!cart) return;
        var applied = (cart.discount_codes || []).some(function (d) {
          return d && d.code && d.code.toLowerCase() === c.toLowerCase() && d.applicable !== false;
        });
        /* the refresh replaced the markup, so re-find the field */
        var live = document.querySelector('[data-aurora-discount]');
        var det = live && live.closest('details');
        var mod = live && live.closest('[data-aurora-modal]');
        var s2 = live && (live.closest('.aurora-cart-disc') || live.closest('[data-aurora-modal]') || live.parentElement);
        if (applied) {
          /* Done — so get out of the way and show the cart. The cart IS the confirmation
             now: the code is named on the line it discounts and the total has changed, so
             leaving the panel open over it hides the answer behind the question. */
          if (live) live.value = '';
          discountMsg(s2, '', true);
          if (det) det.open = false;
          closeAll();
        } else {
          /* A REJECTED code is the one case worth staying open for: the shopper has to see
             why nothing happened and retype it. The re-render rebuilds the stack with every
             modal hidden, so without re-opening, the message would be written into a sheet
             nobody can see — correct and invisible. */
          if (det) det.open = true;
          if (mod) open(mod.getAttribute('data-aurora-modal'));
          discountMsg(s2, (live && live.dataset.tInvalid) || '', false);
        }
      })
      .catch(function () { discountMsg(scope, T.tFailed || '', false); });
  }
  function money(c) {
    try { return (c / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }); }
    catch (e) { return '$' + (c / 100).toFixed(2); }
  }
  function provinces(scope) {
    var c = scope && scope.querySelector('[data-ship-country]');
    var sel = scope && scope.querySelector('[data-ship-province]');
    var wrap = scope && scope.querySelector('[data-ship-province-wrap]');
    if (!c || !sel || !wrap) return;
    var opt = c.options[c.selectedIndex], list = [];
    // country_option_tags ships each country's provinces as a JSON attribute — no fetch needed
    try { list = JSON.parse(opt && opt.getAttribute('data-provinces') || '[]') || []; } catch (e) {}
    sel.innerHTML = list.map(function (p) { return '<option value="' + esc(p[0]) + '">' + esc(p[1]) + '</option>'; }).join('');
    wrap.hidden = !list.length;
  }

  function rates(scope) {
    if (!scope) return;
    var country = scope.querySelector('[data-ship-country]'), zip = scope.querySelector('[data-ship-zip]'), out = scope.querySelector('[data-ship-results]');
    var wrap = scope.querySelector('[data-ship-province-wrap]'), prov = scope.querySelector('[data-ship-province]');
    if (!out) return;
    var T = scope.dataset; // translated strings from the liquid template
    out.textContent = T.tCalculating || 'Calculating…';
    fetch('/cart/shipping_rates.json?shipping_address[country]=' + encodeURIComponent(country ? country.value : '') +
      '&shipping_address[province]=' + encodeURIComponent(wrap && !wrap.hidden && prov ? prov.value : '') +
      '&shipping_address[zip]=' + encodeURIComponent(zip ? zip.value : ''))
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        out.innerHTML = '';
        var list = res.ok && res.d.shipping_rates;
        if (!list || !list.length) {
          var p = document.createElement('p');
          p.className = 'aurora-modal__rate-msg';
          p.textContent = res.ok ? (T.tNone || 'No shipping available.') : (T.tError || 'Check your address and try again.');
          return out.appendChild(p);
        }
        list.forEach(function (rate) {
          var row = document.createElement('div'); row.className = 'aurora-modal__rate';
          var n = document.createElement('span'); n.textContent = rate.name || T.tShipping || 'Shipping';
          var v = document.createElement('span'); v.textContent = money(parseFloat(rate.price) * 100);
          row.appendChild(n); row.appendChild(v); out.appendChild(row);
        });
      }).catch(function () { out.textContent = T.tFailed || 'Could not fetch rates.'; });
  }

  /* --- 4) RECENTLY VIEWED — empty-cart strip from localStorage --------------- */
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function recent() {
    var boxes = document.querySelectorAll('[data-aurora-recent]');
    if (!boxes.length) return;
    var list = [];
    try { list = JSON.parse(localStorage.getItem('aurora:recently-viewed') || '[]') || []; } catch (e) {}
    boxes.forEach(function (box) {
      var t = box.querySelector('[data-aurora-recent-list]');
      if (!t || t.dataset.done) return;
      var items = list.slice(0, 4);
      if (!items.length) { box.hidden = true; return; }
      t.innerHTML = items.map(function (x) {
        if (!x || !x.u) return '';
        return '<a class="aurora-cart-empty__product" href="' + esc(x.u) + '">' +
          (x.img ? '<img src="' + esc(x.img) + '" alt="" loading="lazy" width="90" height="90">' : '') +
          '<span class="aurora-cart-empty__product-title">' + esc(x.t) + '</span>' +
          '<span class="aurora-cart-empty__product-price">' + esc(x.p) + '</span></a>';
      }).join('');
      t.dataset.done = '1';
      box.hidden = false;
    });
  }

  /* --- 5) UPSELL SLIDER ARROWS (abc puts them in the heading row) ------------ */
  function slide(btn, dir) {
    var list = btn.closest('details').querySelector('.aurora-cart-up__list--slider');
    var card = list && list.querySelector('.aurora-cart-up__item');
    if (card) list.scrollBy({ left: dir * (card.offsetWidth + 12) });
  }

  /* --- one delegated listener for the whole cart ----------------------------- */
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-aurora-up-prev], [data-aurora-up-next]');
    if (arrow) {
      e.preventDefault(); // the arrows live inside <summary> — don't toggle the details
      return slide(arrow, arrow.hasAttribute('data-aurora-up-next') ? 1 : -1);
    }
    var t = e.target.closest('[data-aurora-tool]');
    if (t) return open(t.getAttribute('data-aurora-tool'));
    if (e.target.closest('[data-aurora-modal-close]')) {
      var m = e.target.closest('[data-aurora-modal]');
      var ta = m && m.querySelector('textarea[name="note"]');
      if (ta) ta.dispatchEvent(new Event('change', { bubbles: true })); // commit the note
      return closeAll();
    }
    var a = e.target.closest('[data-aurora-discount-apply]');
    if (a) { var w = a.closest('.aurora-cart-disc') || a.closest('[data-aurora-modal]'); return discount(w && w.querySelector('[data-aurora-discount]')); }
    var c = e.target.closest('[data-ship-calc]');
    if (c) return rates(c.closest('[data-aurora-ship-calc]'));
  });

  document.addEventListener('change', function (e) {
    if (e.target.closest('[data-ship-country]')) provinces(e.target.closest('[data-aurora-ship-calc]'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') return closeAll();
    if (e.key !== 'Enter') return;
    var d = e.target.closest('[data-aurora-discount]');
    if (d) { e.preventDefault(); return discount(d); }
    var z = e.target.closest('[data-ship-zip]');
    if (z) { e.preventDefault(); return rates(z.closest('[data-aurora-ship-calc]')); }
  });

  /* Lay out the blocks the merchant ticked "Pin block" on.

     Sticky siblings sharing an edge overlap instead of stacking, and the offset each one
     needs is the combined height of the pinned blocks between it and that edge — heights
     CSS cannot know, since they change with block order and content. So measure them:
     blocks ABOVE the Products block pin to the top, blocks BELOW it pin to the bottom, and
     each gets a cumulative offset so it comes to rest against the previous pinned block. */
  var PIN = 'aurora-cart-blk--pin';
  function pinLayout() {
    document.querySelectorAll('.cart-drawer .aurora-cart-stack').forEach(function (stack) {
      var kids = Array.prototype.slice.call(stack.children);
      var pivot = -1;
      kids.forEach(function (el, i) { if (el.classList.contains('aurora-cart-items')) pivot = i; });
      if (pivot < 0) pivot = kids.length;            // no Products block → everything pins to the top

      var off = 0;
      kids.forEach(function (el, i) {
        if (i >= pivot || !el.classList.contains(PIN)) return;
        el.setAttribute('data-pin', 'top');
        el.style.setProperty('--aurora-pin-top', off + 'px');
        off += el.offsetHeight;
      });

      off = 0;
      for (var i = kids.length - 1; i > pivot; i--) {
        if (!kids[i].classList.contains(PIN)) continue;
        kids[i].setAttribute('data-pin', 'bottom');
        kids[i].style.setProperty('--aurora-pin-bottom', off + 'px');
        off += kids[i].offsetHeight;
      }
    });
  }

  function boot() {
    gate(); recent(); pinLayout();
    document.querySelectorAll('[data-aurora-ship-calc]').forEach(provinces);
    var d = document.querySelector('#CartDrawer');
    if (d && window.MutationObserver) new MutationObserver(function () { gate(); recent(); pinLayout(); }).observe(d, { childList: true, subtree: true });

    /* Offsets are measured heights, so they MUST be recomputed whenever a pinned block can
       change height — otherwise a block comes to rest at a stale offset and overlaps its
       neighbour again. The observers below are deliberately belt-and-braces: each catches a
       case the others miss, and re-running is cheap (a few offsetHeight reads). */
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(pinLayout);                 // content reflow, discount rows
      document.querySelectorAll('.cart-drawer .' + PIN).forEach(function (el) { ro.observe(el); });
    }
    window.addEventListener('resize', pinLayout);             // viewport / orientation
    window.addEventListener('load', pinLayout);               // images inside a pinned block
    // web fonts land AFTER DOMContentLoaded and reflow every text block
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(pinLayout).catch(function () {});
    // the drawer is hidden until opened — remeasure as it becomes visible
    var cd = document.querySelector('cart-drawer');
    if (cd && window.MutationObserver) {
      new MutationObserver(function () { requestAnimationFrame(pinLayout); })
        .observe(cd, { attributes: true, attributeFilter: ['class'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { gate(); recent(); pinLayout(); });
})();

/* Close the note / shipping / discount sheet when clicking the dimmed area behind it
   (matches the cart + search drawers). Registered once; the sheet itself and its
   triggers are excluded so opening never immediately re-closes. */
(function () {
  if (window.__auroraCartModalOutside) return;
  window.__auroraCartModalOutside = true;
  document.addEventListener('click', function (e) {
    var open = document.querySelector('[data-aurora-modal]:not([hidden])');
    if (!open) return;
    if (e.target.closest('[data-aurora-modal]')) return;      // inside the sheet
    if (e.target.closest('[data-aurora-tool]')) return;        // a trigger
    document.querySelectorAll('[data-aurora-modal]').forEach(function (m) { m.hidden = true; });
    var d = document.querySelector('cart-drawer, .cart-drawer');
    if (d) d.classList.remove('aurora-cart--modal');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    if (!document.querySelector('[data-aurora-modal]:not([hidden])')) return;
    document.querySelectorAll('[data-aurora-modal]').forEach(function (m) { m.hidden = true; });
    var d = document.querySelector('cart-drawer, .cart-drawer');
    if (d) d.classList.remove('aurora-cart--modal');
  });
})();

/* Copy-code button on the cart's Highlighted message block.
   Delegated on document so it survives the section re-render that follows every cart
   change, and so one listener covers however many message blocks a merchant adds.
   The confirmation swaps the hint text rather than firing an alert — the shopper is
   mid-task and a dialog would interrupt it. */
(function () {
  if (window.__auroraCopyCode) return;
  window.__auroraCopyCode = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-aurora-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-aurora-copy');
    if (!code) return;

    var hint = btn.querySelector('[data-copy-hint]');
    var done = function () {
      if (!hint) return;
      if (!hint.dataset.idle) hint.dataset.idle = hint.textContent;
      hint.textContent = hint.dataset.copied || 'Copied';
      btn.classList.add('is-copied');
      clearTimeout(btn.__t);
      btn.__t = setTimeout(function () {
        hint.textContent = hint.dataset.idle;
        btn.classList.remove('is-copied');
      }, 1800);
    };

    /* A throwaway field, for http, older Safari, and — the case that actually bit —
       a clipboard permission REJECTION. The first version passed an empty function as
       the rejection handler, so a denied clipboard left the button silently dead. */
    var fallback = function () {
      try {
        var t = document.createElement('textarea');
        t.value = code;
        t.setAttribute('readonly', '');
        t.style.cssText = 'position:absolute;left:-9999px';
        document.body.appendChild(t);
        t.select();
        document.execCommand('copy');
        document.body.removeChild(t);
        done();
      } catch (err) {}
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, fallback);
      return;
    }
    fallback();
  });
})();
